import { render, staticRenderFns } from "./StationInstrumentForm.vue?vue&type=template&id=bc38dbf2&scoped=true&"
import script from "./StationInstrumentForm.vue?vue&type=script&lang=js&"
export * from "./StationInstrumentForm.vue?vue&type=script&lang=js&"
import style0 from "./StationInstrumentForm.vue?vue&type=style&index=0&id=bc38dbf2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc38dbf2",
  null
  
)

export default component.exports